import __var_0__ from './uppercase_keys.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Convert each object key to uppercase.
*
* @module @stdlib/utils/uppercase-keys
*
* @example
* var uppercaseKeys = require( '@stdlib/utils/uppercase-keys' );
*
* var obj1 = {
*     'a': 1,
*     'b': 2
* };
*
* var obj2 = uppercaseKeys( obj1 );
* // returns { 'A': 1, 'B': 2 }
*/

// MODULES //
var uppercaseKeys = __var_0__;


// EXPORTS //
export default uppercaseKeys;
